/* tslint:disable */
import {
  Patient,
  PatientNotification
} from '../index';

declare var Object: any;
export interface PatientNotificationChainInterface {
  "title": string;
  "creatorId": string;
  "notificationsOrder"?: any;
  "sendNotifications"?: any;
  "id"?: any;
  "patientId"?: any;
  "created"?: Date;
  patient?: Patient;
  notifications?: PatientNotification[];
}

export class PatientNotificationChain implements PatientNotificationChainInterface {
  "title": string;
  "creatorId": string;
  "notificationsOrder": any;
  "sendNotifications": any;
  "id": any;
  "patientId": any;
  "created": Date;
  patient: Patient;
  notifications: PatientNotification[];
  constructor(data?: PatientNotificationChainInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PatientNotificationChain`.
   */
  public static getModelName() {
    return "PatientNotificationChain";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PatientNotificationChain for dynamic purposes.
  **/
  public static factory(data: PatientNotificationChainInterface): PatientNotificationChain{
    return new PatientNotificationChain(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PatientNotificationChain',
      plural: 'PatientNotificationChains',
      path: 'PatientNotificationChains',
      idName: 'id',
      properties: {
        "title": {
          name: 'title',
          type: 'string'
        },
        "creatorId": {
          name: 'creatorId',
          type: 'string'
        },
        "notificationsOrder": {
          name: 'notificationsOrder',
          type: 'any'
        },
        "sendNotifications": {
          name: 'sendNotifications',
          type: 'any',
          default: <any>null
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "patientId": {
          name: 'patientId',
          type: 'any'
        },
        "created": {
          name: 'created',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        patient: {
          name: 'patient',
          type: 'Patient',
          model: 'Patient',
          relationType: 'belongsTo',
                  keyFrom: 'patientId',
          keyTo: 'id'
        },
        notifications: {
          name: 'notifications',
          type: 'PatientNotification[]',
          model: 'PatientNotification',
          relationType: 'hasMany',
          modelThrough: 'PatientChainNotificationsMapping',
          keyThrough: 'patientNotificationId',
          keyFrom: 'id',
          keyTo: 'chainId'
        },
      }
    }
  }
}
